"use client";

import type { DataChannel } from "../DataTable/types";
import { useInjectStyles } from "../utils/useInjectStyles";

export interface ChannelTagProps {
  channel: DataChannel;
  /** S 級可顯示總筆數；其餘通道拿不到總數，傳了也不會顯示。 */
  total?: number;
  /** 完全覆寫文案（例如 BQ 要標出實際的資料截止日）。 */
  text?: string;
}

/**
 * 資料通道徽章（2026-09-02 視覺翻新新增）。
 *
 * 四種通道的篩選與分頁能力天差地遠：
 *   S 級（45 頁）  全欄位可篩、有總筆數、可跳頁
 *   C 級（8 頁）   須先圈定範圍才能查詢
 *   IDX（27 頁）   部分欄位可篩、**無總數**、只能逐頁前後翻
 *   BQ（7 頁）     非即時，T+1 批次資料
 *
 * 原本畫面上毫無提示，使用者要到第 27 個頁面才第一次撞見差異，容易把設計限制
 * 誤報成 bug。固定顯示在頁面標題旁，進頁面第一秒就講清楚。
 *
 * ⚠️ IDX 刻意用中性灰而非藍色：用藍色會讓人以為它跟 S 級一樣強大。
 */
export function ChannelTag({ channel, total, text }: ChannelTagProps) {
  useInjectStyles();
  const label =
    text ??
    (channel === "s"
      ? typeof total === "number"
        ? `⚡ 可即時查 · 共 ${total.toLocaleString("zh-Hant-TW")} 筆`
        : "⚡ 可即時查"
      : channel === "c"
        ? "📌 請先圈定範圍"
        : channel === "idx"
          ? "🔍 深度搜尋 · 部分欄位可篩"
          : "📊 資料為 T+1 批次");
  return <span className={`cui-reset cui-channel cui-channel-${channel}`}>{label}</span>;
}
